var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-form',{attrs:{"readonly":"","table":""}},[_c('el-form-item',{staticClass:"table-full-row",attrs:{"label":"附件"}},[_c('my-upload',{attrs:{"readonly":"","file-guid":_vm.data.fileguid}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }